import { IBaseDataParser } from "../../../core/src/server/parsers/IBaseDataParser";
import { IBetData } from "../../../core/src/server/data/IBetData";

export default class BalanceDataParser implements IBaseDataParser<IBetData> {
    check(data: any): boolean {
        return data?.data?.gameData?.balance;
    }
    parse(data: any): IBetData | IBetData[] {
        let betStatesData : { [bet: number]: {[propName:string]:any} } = {};
        if(data.data.gameData.userState) {
            data.data.gameData.userState.forEach(element => {
                betStatesData[element.bet] = element.data;
            });

        }

        let result: IBetData = {
            balance: parseFloat(data.data.gameData.balance.$numberDecimal || data.data.gameData.balance),
            betStatesData
        }

    
        return result;
    }
}